// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: Arial, sans-serif;
}

a {
  text-decoration: none;
  color: inherit;
}

button {
  cursor: pointer;
}


/* ????????????????????????? */

/* Glass effect */
.glass {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 215, 0, 0.2);
}

.glass-gold {
  background: linear-gradient(135deg, rgba(255, 215, 0, 0.1), rgba(255, 215, 0, 0.05));
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 215, 0, 0.3);
  box-shadow: 0 8px 32px rgba(255, 215, 0, 0.1);
}

/* Gradient card */
.gradient-card {
  background: linear-gradient(135deg, hsl(var(--card)), hsl(var(--background)));
}

/* Shadow effects */
.shadow-elegant {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.shadow-gold {
  box-shadow: 0 4px 20px rgba(255, 215, 0, 0.15);
}

.hover\\:shadow-gold:hover {
  box-shadow: 0 8px 30px rgba(255, 215, 0, 0.25);
}

/* Gold color variables (agar defined nahi hain to) */
:root {
  --gold: 255, 215, 0;
  --gold-light: 255, 228, 100;
  --gold-dark: 218, 165, 32;
}

.border-gold\\/30 {
  border-color: rgba(255, 215, 0, 0.3);
}

.text-gold {
  color: rgb(255, 215, 0);
}

.bg-gold\\/5 {
  background-color: rgba(255, 215, 0, 0.05);
}

.bg-gold\\/10 {
  background-color: rgba(255, 215, 0, 0.1);
}

.hover\\:bg-gold\\/10:hover {
  background-color: rgba(255, 215, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;;AAGA,8BAA8B;;AAE9B,iBAAiB;AACjB;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,oFAAoF;EACpF,2BAA2B;EAC3B,wCAAwC;EACxC,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,6EAA6E;AAC/E;;AAEA,mBAAmB;AACnB;EACE,0CAA0C;AAC5C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA,qDAAqD;AACrD;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":["body {\n  margin: 0;\n  font-family: Arial, sans-serif;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\nbutton {\n  cursor: pointer;\n}\n\n\n/* ????????????????????????? */\n\n/* Glass effect */\n.glass {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 215, 0, 0.2);\n}\n\n.glass-gold {\n  background: linear-gradient(135deg, rgba(255, 215, 0, 0.1), rgba(255, 215, 0, 0.05));\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 215, 0, 0.3);\n  box-shadow: 0 8px 32px rgba(255, 215, 0, 0.1);\n}\n\n/* Gradient card */\n.gradient-card {\n  background: linear-gradient(135deg, hsl(var(--card)), hsl(var(--background)));\n}\n\n/* Shadow effects */\n.shadow-elegant {\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n}\n\n.shadow-gold {\n  box-shadow: 0 4px 20px rgba(255, 215, 0, 0.15);\n}\n\n.hover\\:shadow-gold:hover {\n  box-shadow: 0 8px 30px rgba(255, 215, 0, 0.25);\n}\n\n/* Gold color variables (agar defined nahi hain to) */\n:root {\n  --gold: 255, 215, 0;\n  --gold-light: 255, 228, 100;\n  --gold-dark: 218, 165, 32;\n}\n\n.border-gold\\/30 {\n  border-color: rgba(255, 215, 0, 0.3);\n}\n\n.text-gold {\n  color: rgb(255, 215, 0);\n}\n\n.bg-gold\\/5 {\n  background-color: rgba(255, 215, 0, 0.05);\n}\n\n.bg-gold\\/10 {\n  background-color: rgba(255, 215, 0, 0.1);\n}\n\n.hover\\:bg-gold\\/10:hover {\n  background-color: rgba(255, 215, 0, 0.1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
